// extracted by mini-css-extract-plugin
export default {"thumbnailIcon":"Album_thumbnailIcon__KnPBk"};